<template>
  <!-- 단축키 도움말 모달 (ux-patterns.md §11.3, §3.4) -->
  <a-modal
    :open="visible"
    :title="$t('ecountEtl_shortcutHelp_title')"
    :footer="null"
    :width="520"
    wrap-class-name="shortcut-help-overlay"
    @cancel="$emit('update:visible', false)"
  >
    <a-table
      :data-source="shortcutRows"
      :columns="columns"
      size="small"
      :show-header="false"
      :pagination="false"
      :scroll="{ x: 400 }"
      row-key="key"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'key'">
          <a-tag v-for="k in record.keys" :key="k" style="font-family: monospace;">{{ k }}</a-tag>
        </template>
        <template v-if="column.key === 'desc'">
          {{ record.desc }}
        </template>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-COMMON-006
import { useFeatureFlag } from '../composables/useFeatureFlag.js';

export default {
  name: 'ShortcutHelp',
  props: {
    visible: { type: Boolean, default: false },
  },
  emits: ['update:visible'],
  computed: {
    shortcutRows() {
      const rows = [
        { key: 'r', keys: ['r'], desc: this.$t('ecountEtl_shortcut_forceRefresh') },
        { key: '?', keys: ['?'], desc: this.$t('ecountEtl_shortcut_showHelp') },
        { key: '/', keys: ['/'], desc: this.$t('ecountEtl_shortcut_focusSearch') },
        { key: 'esc', keys: ['Esc'], desc: this.$t('ecountEtl_shortcut_closeModal') },
        { key: 'gd', keys: ['g', 'd'], desc: this.$t('ecountEtl_shortcut_gotoDashboard') },
        { key: 'gr', keys: ['g', 'r'], desc: this.$t('ecountEtl_shortcut_gotoRuns') },
        { key: 'gx', keys: ['g', 'x'], desc: this.$t('ecountEtl_shortcut_gotoDeadLetters') },
        { key: 'gp', keys: ['g', 'p'], desc: this.$t('ecountEtl_shortcut_gotoProducts') },
        { key: 'gt', keys: ['g', 't'], desc: this.$t('ecountEtl_shortcut_gotoTransactions') },
      ];
      // SyncTrigger 단축키는 feature flag on 시에만 표시
      if (useFeatureFlag('VUE_APP_ECOUNT_ETL_SYNC_TRIGGER')) {
        rows.push({ key: 'gs', keys: ['g', 's'], desc: this.$t('ecountEtl_shortcut_gotoSyncTrigger') });
      }
      return rows;
    },
    columns() {
      return [
        { key: 'key', dataIndex: 'keys', width: 140 },
        { key: 'desc', dataIndex: 'desc' },
      ];
    },
  },
};
</script>

<!-- 모달은 document.body로 teleport되므로 scoped 스타일이 닿지 않는다(house precedent: IamConsole.vue).
     wrap-class-name으로 부여한 .shortcut-help-overlay로 스코프를 좁혀 뷰포트 클램프만 적용. -->
<style>
@media (max-width: 767px) {
  .shortcut-help-overlay .ant-modal {
    max-width: calc(100vw - 24px);
    margin: 8px auto;
  }
  .shortcut-help-overlay .ant-modal-body {
    max-height: 70vh;
    max-height: 70dvh;
    overflow-y: auto;
  }
}
</style>
